var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"btn-return",on:{"click":function($event){return _vm.$router.go(-1)}}},[_c('i',{staticClass:"fas fa-arrow-left mr-2"}),_vm._v(" Voltar ")])}
var staticRenderFns = []

export { render, staticRenderFns }